import React, { useMemo } from "react";
import { Clock } from "lucide-react";
import Modal from "../../../components/Modal";
import { formatParado } from "../../SequenciaPedidos/utils/formatTempo";
import type { PainelPedidoAtrasado } from "../utils/pedidosAtrasadosPainel";
import { contarPedidosAtrasadosUnicos } from "../utils/pedidosAtrasadosPainel";

interface PedidosAtrasadosModalProps {
  isOpen: boolean;
  onClose: () => void;
  itens: PainelPedidoAtrasado[];
}

export const PedidosAtrasadosModal: React.FC<PedidosAtrasadosModalProps> = ({
  isOpen,
  onClose,
  itens,
}) => {
  const pedidosCount = useMemo(
    () => contarPedidosAtrasadosUnicos(itens),
    [itens],
  );

  const agrupadoPorStatus = useMemo(() => {
    const map = new Map<string, PainelPedidoAtrasado[]>();
    for (const item of itens) {
      const list = map.get(item.statusLabel) ?? [];
      list.push(item);
      map.set(item.statusLabel, list);
    }
    return Array.from(map.entries());
  }, [itens]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Pedidos acima de 10 min (${pedidosCount})`}
      panelClassName="max-w-lg"
      compactHeader
      bodyClassName="max-h-[70vh] overflow-y-auto p-4"
    >
      {itens.length === 0 ? (
        <p className="text-sm text-neutral-600">
          Nenhum pedido parado há mais de 10 minutos no momento.
        </p>
      ) : (
        <div className="space-y-4">
          {agrupadoPorStatus.map(([statusLabel, rows]) => (
            <section key={statusLabel}>
              <h4 className="mb-2 flex items-center gap-2 text-sm font-semibold text-amber-900">
                <Clock size={16} className="shrink-0" aria-hidden />
                {statusLabel}
                <span className="font-normal text-neutral-500">
                  ({rows.length})
                </span>
              </h4>
              <ul className="divide-y divide-neutral-100 rounded-md border border-neutral-200">
                {rows.map((item) => (
                  <li key={item.key} className="px-3 py-2.5 text-sm">
                    <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
                      <span className="font-bold text-neutral-900">
                        #{item.displayId}
                        {item.tituloSalao ? ` · ${item.tituloSalao}` : ""}
                      </span>
                      <span className="text-xs font-medium text-amber-800">
                        {formatParado(item.segundos)}
                      </span>
                    </div>
                    {item.tituloSalao ? null : item.customerName ? (
                      <p className="mt-0.5 text-neutral-600">
                        {item.customerName}
                      </p>
                    ) : null}
                    <p className="mt-0.5 text-xs text-neutral-500">
                      {item.statusLabel}
                    </p>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      )}
    </Modal>
  );
};
